export default __webpack_public_path__ + "static/tcm-navbar-img-2ae004cabf8b241e5f6e439ea63d6c4b.png";